import Logger from '../Logger';

const logger = new Logger();

const initialState = { };
/**
 * 返回 peer 字面量对象
 * @param {*} state
 * @param {*} action
 * @returns
 */
const peer = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'ADD_PEER': {

			const { peer } = action.payload;

			if (state) {
				return {
					...state,
					...peer
				}
			} else {
				return peer;
			}
		}
		case 'SET_PEER_DISPLAY_NAME': {
			const { displayName } = action.payload;
			return {
				...state,
				displayName
			};
		}
		case 'SET_PEER_VIDEO_PAUSED': {
			const { flag } = action.payload;
			return {
				...state,
				videoPaused: flag
			};
		}
		case 'SET_PEER_VIDEO_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				peerVideoInProgress: flag
			};
		}
		case 'SET_PEER_AUDIO_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				peerAudioInProgress: flag
			};
		}
		case 'SET_PEER_SCREEN_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				peerScreenInProgress: flag
			};
		}
		case 'SET_PEER_KICK_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				peerKickInProgress: flag
			};
		}
		case 'SET_PEER_AUDIO_MUTE': {
			const { audioMuted } = action.payload;
			return {
				...state,
				audioMuted   // true:静音; false:取消静音
			};
		}
		case 'SET_PEER_VIDEO_MUTE': {
			const { videoMuted } = action.payload;

			return {
				...state,
				videoMuted   // true:开启视频; false:关闭视频
			};
		}
		
		case 'SET_PEER_IS_CAMERA_ON': {
			const { isCameraOn } = action.payload;

			return {
				...state,
				isCameraOn   // true:摄像头开启; false:摄像头关闭
			};
		}
		case 'SET_PEER_AUDIO_AVAILABLE': {

			const { audioAvailable } = action.payload;

			return {
				...state,
				audioAvailable   // true:音频设备可用; false:音频设备不可用
			};
		}
		case 'SET_PEER_VIDEO_AVAILABLE': {

			const { videoAvailable } = action.payload;

			return {
				...state,
				videoAvailable   // true:视频设备可用; false:视频设备不可用
			};
		}

		case 'SET_PEER_RAISED_HAND_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				raisedHandInProgress : flag
			};
		}
		case 'ADD_CONSUMER':
		{
			const { consumerId } = action.payload;
			const consumers = [ ...state.consumers, consumerId ];

			return { ...state, consumers };
		}

		case 'REMOVE_CONSUMER':
		{
			const { consumerId } = action.payload;
			const consumers = state.consumers.filter((consumer) =>
				consumer !== consumerId);

			return { ...state, consumers };
		}

		case 'SET_PEER_PICTURE':
		{
			const { picture } = action.payload;
			return { ...state, picture };
		}

		case 'ADD_PEER_ROLE':
		{
			const { role } = action.payload;
			const roles = [ ...state.roles, role ];

			return { ...state, roles };
		}

		case 'REMOVE_PEER_ROLE':
		{
			const { role } = action.payload;
			const roles = state.roles.filter((role) =>
				role !== role);

			return { ...state, roles };
		}

		case 'STOP_PEER_AUDIO_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				stopPeerAudioInProgress : flag
			};
		}
		case 'STOP_PEER_VIDEO_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				stopPeerVideoInProgress : flag
			};
		}

		case 'STOP_PEER_SCREEN_SHARING_IN_PROGRESS': {
			const { flag } = action.payload;
			return {
				...state,
				stopPeerScreenSharingInProgress : flag
			};
		}

		case 'SET_PEER_RAISED_HAND': {
			const { 
				raisedHand,
				raisedHandTimestamp 
			} = action.payload;
			
			return {
				...state,
				raisedHand          : raisedHand,
				raisedHandTimestamp : raisedHandTimestamp
			};
		}

		case 'SET_PEER_COHOST': {
			const { isCohost } = action.payload;
			return {
				...state,
				isCohost,             // true:联席主持人; false:非联席主持人
				updateAt : Date.now()
			};
		}

		default:
			return state;
	}
};

const peers = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'ADD_PEER':
		{
			const { peer: newPeer } = action.payload;

			const oldPeer = state[newPeer.id];

			if (oldPeer) {

				return {
					...state,
					[oldPeer.id]: {
						...newPeer,
						...oldPeer
					}
				};
			} else {

				return {
					...state,
					[newPeer.id]: peer(undefined, action)
				};
			}
		}

		case 'REMOVE_PEER':
		{
			const { peerId } = action.payload;
			const newState = { ...state };

			delete newState[peerId];

			return newState;
		}

		case 'SET_PEER_DISPLAY_NAME':
		case 'SET_PEER_VIDEO_PAUSED':
		case 'SET_PEER_VIDEO_IN_PROGRESS':
		case 'SET_PEER_AUDIO_IN_PROGRESS':
		case 'SET_PEER_SCREEN_IN_PROGRESS':
		case 'SET_PEER_RAISED_HAND':
		case 'SET_PEER_RAISED_HAND_IN_PROGRESS':
		case 'SET_PEER_PICTURE':
		case 'ADD_CONSUMER':
		case 'ADD_PEER_ROLE':
		case 'REMOVE_PEER_ROLE':
		case 'STOP_PEER_AUDIO_IN_PROGRESS':
		case 'STOP_PEER_VIDEO_IN_PROGRESS':
		case 'STOP_PEER_SCREEN_SHARING_IN_PROGRESS':
		case 'SET_PEER_AUDIO_MUTE':
		case 'SET_PEER_VIDEO_MUTE':
		case 'SET_PEER_AUDIO_AVAILABLE':
		case 'SET_PEER_VIDEO_AVAILABLE':
		case 'SET_PEER_COHOST':
		case 'SET_PEER_IS_CAMERA_ON':	
		{
			const { peerId } = action.payload;

			const oldPeer = state[peerId];

			if (!oldPeer) {

				if (action.type === 'SET_PEER_RAISED_HAND') {

					const _peer = {
						[peerId]: {
							...peer(undefined, action),
							id: peerId
						}
					};

					const _peers = {
						...state,
						..._peer
					};

					return _peers;
				} else {

					//throw new Error('no Peer found');
					return state;
				}
			}

			return {
				...state,
				[oldPeer.id]: peer(oldPeer, action)
			};
		}

		case 'SET_PEER_KICK_IN_PROGRESS':
		case 'REMOVE_CONSUMER':
		{
			const oldPeer = state[action.payload.peerId];

			// NOTE: This means that the Peer was closed before, so it's ok.
			if (!oldPeer)
				return state;

			return {
				...state,
				[oldPeer.id]: peer(oldPeer, action)
			};
		}

		case 'REPLACE_PEER_CONSUME':
		{
			// 将 srcPeerId 中的 consumerId 迁移至 destPeerId
			const {
				srcPeerId,
				destPeerId,
				consumerId
			} = action.payload;

			const _srcPeer = state[srcPeerId];
			const _destPeer = state[destPeerId];

			if (!_srcPeer || !_destPeer) {  // 如果任意一个peer不存在,则什么都不处理

				return state;

			} else {

				if (_srcPeer.consumers.includes(consumerId)) {

					_srcPeer.consumers = _srcPeer.consumers.filter(v => v !== consumerId);
					_destPeer.consumers = [..._destPeer.consumers, consumerId];

					return {
						...state,
						[srcPeerId]: _srcPeer,
						[destPeerId]: _destPeer
					}

				} else {

					return state;
				}
			}
		}

		case 'CLEAR_PEERS':
		{
			return initialState;
		}

		default:
			return state;
	}
};

export default peers;
